import type { ReactNode } from 'react'

type ArticleLayoutProps = {
  /** 本文カラム。`<article>` ごと渡す（本文内の余白はページごとに違うため） */
  main: ReactNode
  /** 右カラム（フォーム・プロフィールなど）の中身。`<aside>` はこちらで描く */
  aside: ReactNode
}

/**
 * 記事詳細の 2 カラム外枠。Figma: （PC）資料ページ・コラム記事・セミナー詳細・導入事例詳細。
 * 本文（740）と右カラム（420）の 2 カラムで、lg では余白を詰めて右カラムを 320 に縮める。
 * lg 未満は右カラムが本文の下に回る。lg 以上は右カラムがヘッダーの下に追従する。
 */
export function ArticleLayout({ main, aside }: ArticleLayoutProps) {
  return (
    <section className="bg-surface px-6 py-12 lg:px-panelx lg:py-panelx">
      <div className="mx-auto flex max-w-wide flex-col gap-14 lg:flex-row lg:items-start lg:gap-10 xl:gap-20">
        {main}
        <aside className="w-full shrink-0 lg:rail-sticky lg:w-80 xl:w-rail">
          {aside}
        </aside>
      </div>
    </section>
  )
}
